import { httpGet, httpPost, httpPatchMerge, httpDelete } from './../http'
import type { TEntityId } from '~/types/models'
import type { ILeadSourceEvent } from '~/types/leadSource/models'

const apiEntityPath = '/api/leadsourceevents'

export async function getLeadSourceEvents() {
  const callingMn = getLeadSourceEvents.name
  const apiPath = `${apiEntityPath}`
  return httpGet<ILeadSourceEvent[]>({ callingMn, apiPath })
}

export async function createLeadSourceEvent(entity: ILeadSourceEvent) {
  const callingMn = createLeadSourceEvent.name
  const apiPath = apiEntityPath
  return httpPost<ILeadSourceEvent>({ callingMn, apiPath, entity })
}

export async function updateLeadSourceEvent(
  entityData: Partial<ILeadSourceEvent>,
  id: TEntityId
) {
  const callingMn = updateLeadSourceEvent.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialLeadSourceEvent = Partial<ILeadSourceEvent>
  return httpPatchMerge<TPartialLeadSourceEvent>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteLeadSourceEvent(entityData: ILeadSourceEvent) {
  const callingMn = deleteLeadSourceEvent.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
